// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"444":"ba6c279a","505":"c66605da","853":"2524a63f"}[chunkId] + ".css";
};